import React from 'react';
import './SelectionToggle.css';

/**
 * SelectionToggle Component
 * 
 * Renders a toggle button to switch between Normal Mode and Selection Mode.
 * In Normal Mode, single-click opens folders or downloads files.
 * In Selection Mode, single-click toggles item selection for bulk operations.
 * 
 * **Feature: selection-mode-toggle**
 * **Validates: Requirements 3.1, 3.5**
 * - 3.1: THE FileExplorer SHALL display a Selection_Toggle button in the toolbar area
 * - 3.5: THE Selection_Toggle SHALL display visual feedback indicating the current mode
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isSelectionMode - Current mode state (true = Selection Mode, false = Normal Mode)
 * @param {function} props.onToggle - Callback when toggle is clicked
 * @param {boolean} props.disabled - Whether the toggle is disabled
 */
const SelectionToggle = ({ isSelectionMode, onToggle, disabled = false }) => {
  return (
    <button
      className={`selection-toggle ${isSelectionMode ? 'active' : ''}`}
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={isSelectionMode}
      aria-label={isSelectionMode ? 'Exit selection mode' : 'Enter selection mode'}
      data-testid="selection-toggle"
    >
      {isSelectionMode ? 'Done' : 'Select'}
    </button>
  );
};

export default SelectionToggle;
